import { render, staticRenderFns } from "./ContactKicked.vue?vue&type=template&id=6452191d&"
import script from "./ContactKicked.vue?vue&type=script&lang=js&"
export * from "./ContactKicked.vue?vue&type=script&lang=js&"
import style0 from "./ContactKicked.vue?vue&type=style&index=0&id=6452191d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports